module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_catalogue_remoteEntry_mjs_3573ee71__;